import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock } from 'react-bootstrap'
import Select from "react-select";

import { PropTypes } from 'prop-types';

export class ScheduleActiveForm extends Component {
    static contextTypes = {
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            planningEditions: []
        };
    }

    componentDidMount() {
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    updateDraftPlanning(edition) {
        this.setState({
            planningEditions: edition.objects.planning
        });
    }

    // ----------------------

    renderEditionFormGroup(formType, schedule) {
        const { planningEditions } = this.state;

        if ("create" === formType) {
            return (
                <FormGroup controlId="formEdition">
                    <ControlLabel>Edição de Planeamento</ControlLabel>
                    <Select
                        className="custom-multiselect"
                        placeholder="Sem Edição"
                        noOptionsMessage={() => "Sem Edições de Configuradas"}
                        onChange={(e) => this.props.onSelectValue(null === e ? undefined : e.id, "planningEdition")}
                        options={planningEditions}
                        isMulti={false}
                        isClearable={true}
                        getOptionValue={value => value.id}
                        getOptionLabel={label => label.name}
                        value={planningEditions.find(pEdition => pEdition.id === schedule.planningEdition)}
                    />
                </FormGroup>
            );
        }

        return null;
    }

    render() {
        const { form } = this.props;

        if(undefined === form) {
            return null;
        }

        const { show, setOfDayTypes } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {this.renderEditionFormGroup(form.type, form.obj)}

                        <FormGroup controlId="formName" validationState={form.nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.name}
                                placeholder="Introduza o Nome"
                                onChange={(e) => this.props.onChangeValue(e, "name")}
                            />
                            {form.nameInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formLineRegions">
                            <ControlLabel>Conjunto de Tipos de Dia</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione um Conjunto de Tipos de Dia..."
                                noOptionsMessage={() => "Sem Conjuntos de Tipos de Dia Configurados"}
                                onChange={(e) => this.props.onSelectValue(e, "setOfDayTypes")}
                                options={setOfDayTypes}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    if (null !== form.obj.setOfDayTypes && undefined !== form.obj.setOfDayTypes) {
                                        return form.obj.setOfDayTypes.id === a.id;
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={form.obj.setOfDayTypes}
                            />
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        <Button onClick={() => this.props.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
